import { Component, input, output } from '@angular/core';
import { Realisation } from 'src/app/classes/realisation';
import type { RealisationRow } from 'src/app/components/hour-control/hour-control.types';
import { AuthorisationService } from 'src/app/services/auth/authorisation.service';

@Component({
    selector: 'app-realisation-row',
    standalone: false,
    templateUrl: './realisation-row.component.html',
    styleUrl: './realisation-row.component.scss',
    host: {
        '[class.first-group]': 'row().isFirstGroup',
        '[class.last-group]': 'row().isLastGroup',
    },
})
export class RealisationRowComponent {
    readonly disabled = input(false);
    readonly row = input.required<RealisationRow>();
    readonly selectionMode = input(false);

    readonly approveRequested = output<void>();
    readonly approveAllRequested = output<void>();
    readonly removeAllRequested = output<void>();
    readonly restoreRequested = output<void>();
    readonly removeRequested = output<void>();
    readonly timeEdit = output<{ field: 'begindate' | 'enddate'; addToCurrentTime: number }>();
    readonly projectEdit = output<void>();
    readonly pauseUpdated = output<Realisation[]>();

    readonly canApproveHours = AuthorisationService.canApproveHours();

    get hasMessages(): boolean {
        const realisation = this.row().realisation;

        return !!(realisation.comment_user || realisation.comment_manager || realisation.comment_user_approved);
    }

    approveAllInGroup(event: Event): void {
        event.preventDefault();
        event.stopPropagation();

        this.approveAllRequested.emit();
    }

    removeAll(event: Event): void {
        event.preventDefault();
        event.stopPropagation();

        this.removeAllRequested.emit();
    }
}
